<template>
  <form-field :id="id" :title="title" :error-message="errorMessage" :show-label="showLabel">
    <div :class="$style.wrapper">
      <select
        :id="id"
        :name="id"
        @input="$emit('update:modelValue', $event.target.value)"
        @change="$emit('change', $event.target.value)"
      >
        <option v-if="noValueText" :value="null" :selected="modelValue === null">
          {{ noValueText }}
        </option>
        <optgroup
          v-for="optionGroup in optionGroups"
          :key="optionGroup.name"
          :label="optionGroup.name"
        >
          <option
            v-for="option in optionGroup.options"
            :key="option.value"
            :value="option.value"
            :selected="option.value === modelValue"
          >
            {{ option.name }}
          </option>
        </optgroup>
      </select>
      <icon icon="dropdown" />
    </div>
  </form-field>
</template>

<script>
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import FormField from '@/components/generic/presentational/atoms/formField/FormField.vue'

export default {
  components: {
    Icon,
    FormField,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    optionGroups: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: [String, Number],
      required: false,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    noValueText: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['change', 'update:modelValue'],
}
</script>

<style scoped module lang="scss">
.wrapper {
  position: relative;

  &::before {
    $margin: 2px;

    content: '';
    position: absolute;
    top: $margin;
    right: $margin;
    bottom: $margin;
    background: $white;
    width: 2em;
    pointer-events: none;
  }
}

svg {
  @include icon(0.5em);

  position: absolute;
  right: 1em;
  top: 50%;
  margin-top: -0.2em;
  pointer-events: none;
}
</style>
